import React from 'react';
import { Phone, MessageCircle, ArrowUp } from 'lucide-react';
import { Button } from './ui/button';
import { academyInfo } from '../data/mockData';

const FinalCTA = () => {
  const handleCall = () => {
    window.location.href = `tel:${academyInfo.phone}`;
  };

  const handleWhatsApp = () => {
    window.open(`https://wa.me/91${academyInfo.whatsapp}?text=Hi, I want to enquire about stock market courses and join the upcoming batch`, '_blank');
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-16 sm:py-20 bg-gradient-to-br from-green-600 to-green-700 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Urgency Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full mb-6 shadow-lg">
            <span className="w-2 h-2 bg-red-600 rounded-full animate-pulse"></span>
            <span className="text-sm font-bold text-red-600">Limited Seats Available</span>
          </div>

          {/* Main Heading */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
            Don't Miss the Upcoming Batch!
          </h2>

          {/* Sub-heading */}
          <p className="text-lg sm:text-xl text-green-50 mb-4 max-w-2xl mx-auto leading-relaxed">
            Limited seats per batch to ensure quality training and personal attention
          </p>
          
          <p className="text-base text-green-100 mb-10 max-w-2xl mx-auto">
            Join <span className="font-bold">Stocks Vision Academy, Bhopal</span> and start your journey towards becoming a confident trader
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <Button 
              onClick={handleCall}
              size="lg"
              className="w-full sm:w-auto bg-white hover:bg-gray-100 text-green-700 px-8 py-6 text-lg font-bold shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
            >
              <Phone className="mr-2 h-5 w-5" />
              Call Now: {academyInfo.phone}
            </Button>
            <Button 
              onClick={handleWhatsApp}
              size="lg"
              className="w-full sm:w-auto bg-green-800 hover:bg-green-900 text-white px-8 py-6 text-lg font-bold shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
            >
              <MessageCircle className="mr-2 h-5 w-5" />
              WhatsApp Now
            </Button>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap justify-center gap-6 text-white">
            <div className="flex items-center gap-2">
              <span className="text-green-200">✓</span>
              <span className="text-sm font-semibold">Practical Training</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-green-200">✓</span>
              <span className="text-sm font-semibold">Small Batch Size</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-green-200">✓</span>
              <span className="text-sm font-semibold">Post-Course Support</span>
            </div>
          </div>

          {/* Scroll to Top Button */}
          <div className="mt-12">
            <Button
              onClick={scrollToTop}
              variant="ghost"
              className="text-white hover:bg-green-800 transition-colors"
            >
              <ArrowUp className="h-5 w-5 mr-2" />
              Back to Top
            </Button>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-10 left-10 w-24 h-24 bg-white rounded-full blur-3xl opacity-10"></div>
      <div className="absolute bottom-10 right-10 w-32 h-32 bg-white rounded-full blur-3xl opacity-10"></div>
    </section>
  );
};

export default FinalCTA;
